import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useGetFoodCategoriesQuery } from '../../../redux/slices/foodCategorySlice';

import styles from '../../../../stylesheets/public/components/List.module.postcss';

function CategoryList({ vehicleType }) {
  const { data = {} } = useGetFoodCategoriesQuery();
  const foodCategories = data.food_categories || [];

  if (!foodCategories || (foodCategories && foodCategories.length < 1)) {
    return null;
  }

  return (
    <div>
      <h3>Browse by cuisine</h3>
      <div className={styles.List_items}>
        {foodCategories.map((cat) => (
          <div
            className={styles.List_item}
            key={cat.id}
          >
            <Link to={`/search?food_categories=${cat.id}`}>
              {cat.name} food {vehicleType.toLowerCase()}s
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

CategoryList.propTypes = {
  vehicleType: PropTypes.string.isRequired,
};

export default CategoryList;
